module.exports = __webpack_public_path__ + "static/img/cloud22.890acd3f.png";